import GridCell from "../GridCell/GridCell";
import { ReactNode } from "react";

interface GridRowProps {
  children: ReactNode | ReactNode[];
}

const GridPresetWideList = ({ children }: GridRowProps) => (
  <GridCell
    startColsDesktop={2}
    spanColsDesktop={10}
    startColsTablet={1}
    spanColsTablet={6}
    startColsMobile={1}
    spanColsMobile={6}
  >
    {children}
  </GridCell>
);

export default GridPresetWideList;
